import type { NestedKeyOf } from '@/features/shared/types'
import type { ContextDefault, ValidateurResult } from './Regle'
import { objectGetValueWithNestedKey } from '@/features/shared/tools'

type ReglePreCallbackAnonymous<TModel, TContext = ContextDefault, TGlobalModele = TModel> = (
  value: any,
  model: any,
  globalModel: Readonly<TGlobalModele>,
  context: Readonly<TContext>,
) => ValidateurResult

export function targetPreBuilder<
  TModel extends object,
  TContext = ContextDefault,
  TGlobalModele extends object = TModel,
>() {
  return function targetPre(
    path: NestedKeyOf<TGlobalModele>,
    precondition: ReglePreCallbackAnonymous<TModel, TContext, TGlobalModele>,
  ) {
    return function (_value: any, _parent: any, model: TGlobalModele, context: TContext) {
      const targetValue = objectGetValueWithNestedKey(model, path)
      const parentPath = path.split('.').slice(0, -1).join('.') as NestedKeyOf<TGlobalModele>
      const parentValue = parentPath === '' ? model : objectGetValueWithNestedKey(model, parentPath)
      return precondition(targetValue as any, parentValue as any, model, context)
    }
  }
}

